import React, { useContext } from 'react'
import classNames from 'classnames'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const RetailCTAModule = () => {
  return (
    <section className='mt-[54px]' data-testid='retailCTA'>
      <div className='bg-gray-0 rounded-lg block md:flex items-center px-6 md:px-8 py-8 md:py-[60px]'>
        <div className='flex justify-center md:block md:mr-8'>
          <img
            className='max-w-[323px]'
            src='https://images.ctfassets.net/tgv5pu8pgmos/1gFdkPhUdEASSgxeJoWju3/986f30cf36329f1e46a567b7feacff5c/Retail-UI-Bulk-item-Management.png'
            alt=''
          />
        </div>
        <div>
          <Typography
            variation='default'
            as='h3'
            classes='font-effra text-center md:text-left lg:font-semibold text-[26px] md:text-[31px] leading-8 md:leading-10 mb-4'
            allowHtml
          >
            {
              '<span class="text-brand-50">Toast Retail</span> can help </br> create seamless guest experiences for your retail and foodservice needs'
            }
          </Typography>
          <Button
            href='/request-retail-demo'
            target='_blank'
            variation='primary'
            className='mt-4'
          >
            Get a free demo
          </Button>
        </div>
      </div>
    </section>
  )
}

export default RetailCTAModule
